import Script from "next/script";
import {qoohooCheckoutUrl, qoohooSuperCheckoutUrl} from "../constants/domain";

export default function CheckoutScript({isCustomDomain = false, enableNewCheckout = false}) {
  let scriptUrl = 'https://checkout.razorpay.com/v1/checkout.js';

  if (enableNewCheckout) {
    scriptUrl = qoohooSuperCheckoutUrl;
  } else if(isCustomDomain) {
    scriptUrl = qoohooCheckoutUrl;
  }
  
  return (
    <Script
      strategy="afterInteractive"
      src={scriptUrl}
    />
  );
}
